module.exports = __webpack_public_path__ + "static/media/spinning.f74388a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/spinning.png
// module id = 109
// module chunks = 0